import { render, staticRenderFns } from "./RelatoriosCredenciamento.vue?vue&type=template&id=227fc2df"
import script from "./RelatoriosCredenciamento.vue?vue&type=script&lang=js"
export * from "./RelatoriosCredenciamento.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosCredenciamento.vue?vue&type=style&index=0&id=227fc2df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports